import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import UserName from '../../atoms/UserName/UserName';
import TekionLogo from '../../atoms/TekionLogo/TekionLogo';
import GlobalSearch from '../GlobalSearch';
import Notifications from '../Notifications/Notifications';
import { EMPTY_OBJECT, NO_OP } from '../../constants/Constants';
import { EMPTY_ARRAY, EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import GetHelp from '../../atoms/GetHelp/GetHelp';
import TodoIcon from '../../molecules/Todo/TodoIcon/TodoIcon';
import { isEmpty } from '../../utils/helper';
import TimesheetRemainder from '../../atoms/TimesheetRemainder';
import { fetchPusherCred } from '../../api/Header';
const Header = props => {
  const {
    apiBaseUrl,
    userDetails,
    isPartnerSite,
    newFeatures,
    chatS3Url,
    fetchChatConfig,
    setPusherCred,
    settingsUrl,
    getChatAccessToken,
    enableGlobalSearch,
    isNotificationEnabled,
    showTodo,
    renderRightActions,
    notificationsBaseUrl
  } = props;
  const [isSearchExpandedInMobile, setIsSearchExpandedInMobile] = useState(false);
  useEffect(() => {
    const {
      initUserEmail,
      fetchUnreadNotificationsCount,
      isNotificationEnabled
    } = props;
    initUserEmail();
    if (isNotificationEnabled) {
      fetchUnreadNotificationsCount(apiBaseUrl, notificationsBaseUrl);
    }
    fetchPusherCred(apiBaseUrl).then(_ref => {
      let {
        data
      } = _ref;
      setPusherCred(data);
    });
  }, EMPTY_ARRAY);
  useEffect(() => {
    if (userDetails && userDetails.preferred_language) {
      setUserLanguageEvent(userDetails.preferred_language);
    }
  }, [userDetails.preferred_language]);
  const setUserLanguageEvent = userLanguage => {
    const event = new CustomEvent('userLanguageChanged', {
      detail: userLanguage
    });
    document.dispatchEvent(event);
  };
  const onMobileSearchIconClick = () => {
    setIsSearchExpandedInMobile(true);
  };
  const onCloseSearchIcon = () => {
    setIsSearchExpandedInMobile(false);
  };
  const updatedApiBaseUrl = !isEmpty(notificationsBaseUrl) ? notificationsBaseUrl : apiBaseUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: "header-container ".concat(enableGlobalSearch ? 'withGlobalSearch' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: isSearchExpandedInMobile ? 'hidden-mobile' : ''
  }, /*#__PURE__*/React.createElement(TekionLogo, {
    apiBaseUrl: apiBaseUrl
  })), enableGlobalSearch && /*#__PURE__*/React.createElement("div", {
    className: "middle-menu"
  }, /*#__PURE__*/React.createElement(GlobalSearch, _extends({}, props, {
    isSearchExpandedInMobile: isSearchExpandedInMobile,
    onCloseSearchIcon: onCloseSearchIcon,
    onMobileSearchIconClick: onMobileSearchIconClick
  }))), /*#__PURE__*/React.createElement("div", {
    className: "right-menu"
  }, !isPartnerSite && /*#__PURE__*/React.createElement(GetHelp, {
    chatS3Url: chatS3Url,
    isPartnerSite: isPartnerSite,
    apiBaseUrl: apiBaseUrl,
    fetchChatConfig: fetchChatConfig,
    userDetails: userDetails,
    getChatAccessToken: getChatAccessToken
  }), renderRightActions && /*#__PURE__*/React.createElement("div", {
    class: "rightActions"
  }, renderRightActions()), isNotificationEnabled && /*#__PURE__*/React.createElement(Notifications, _extends({}, props, {
    apiBaseUrl: updatedApiBaseUrl
  })), /*#__PURE__*/React.createElement(TimesheetRemainder, {
    apiBaseUrl: apiBaseUrl
  }), /*#__PURE__*/React.createElement("a", {
    className: "header-settings",
    href: settingsUrl
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-settings"
  })), showTodo && /*#__PURE__*/React.createElement(TodoIcon, props), /*#__PURE__*/React.createElement(UserName, _extends({
    apiBaseUrl: apiBaseUrl
  }, props))));
};
Header.propTypes = {
  apiBaseUrl: PropTypes.string.isRequired,
  settingsUrl: PropTypes.string,
  userDetails: PropTypes.object,
  initUserEmail: PropTypes.func,
  fetchChatConfig: PropTypes.func,
  fetchUnreadNotificationsCount: PropTypes.func,
  email: PropTypes.string,
  isPartnerSite: PropTypes.bool,
  isFetchApiSuccess: PropTypes.bool,
  chatS3Url: PropTypes.string,
  enableGlobalSearch: PropTypes.bool,
  isNotificationEnabled: PropTypes.bool,
  showTodo: PropTypes.bool,
  renderRightActions: PropTypes.func,
  notificationsBaseUrl: PropTypes.string
};
Header.defaultProps = {
  settingsUrl: '/app/settings',
  userDetails: {},
  initUserEmail: null,
  fetchChatConfig: null,
  fetchUnreadNotificationsCount: NO_OP,
  email: '',
  isPartnerSite: false,
  isFetchApiSuccess: false,
  chatS3Url: '',
  enableGlobalSearch: false,
  isNotificationEnabled: false,
  showTodo: false,
  renderRightActions: null,
  notificationsBaseUrl: EMPTY_STRING
};
export default Header;